<script lang="ts" setup></script>

<template>
  <a href="https://retaintive.ai/terms" target="_blank" rel="noopener noreferrer">
    <UiButton variant="link" class="px-0 font-normal underline text-muted-foreground">
      Terms of Service
    </UiButton>
  </a>
</template>

<style scoped></style>
